import { observer } from 'mobx-react';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/repatch-logo.png';
import whatsappIcon from '../assets/images/whatsapp.png';
import styles from './styles/RepatchHeader.module.css';
import { classnames } from '../helpers/misc';
import { useStores } from '../context/context';

function RepatchHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const menuButtonRef = useRef(null);
  const navigate = useNavigate();
  const { authStore } = useStores();

  useEffect(() => {
    const handleClick = (event) => {
      if (
        menuRef.current &&
        menuButtonRef.current &&
        !menuRef.current.contains(event.target) &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  const navigateTo = async (route) => {
    setMenuOpen(false);
    if (route !== 'logout') {
      navigate(route);
    } else {
      await authStore.logout();
      navigate('/');
    }
  };

  return (
    <header className={styles.headerBg}>
      <div className={styles.headerContainer}>
        <div className={styles.logoBlock}>
          <Link to="https://www.repatch.co.uk" className={styles.logoLink}>
            <img src={logo} alt="Repatch" className={styles.logoImg} />
            <p className={styles.logoText}>REPATCH</p>
          </Link>
          <div className={styles.subtitleBlock}>
            <p className={styles.subtitle}>Repair without leaving your home</p>
            <p className={styles.location}>Now UK-wide</p>
          </div>
        </div>
        <div className={styles.rightControls}>
          <a
            href="https://wa.me/447475703912"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.whatsAppLink}
            aria-label="Chat on WhatsApp"
          >
            <img src={whatsappIcon} alt="WhatsApp" className={styles.whatsAppIcon} />
            <span className={styles.whatsAppText}>
            <span className={styles.whatsAppLabel}>Chat on WhatsApp</span>
            </span>
          </a>
          <button
            className={styles.menuButton}
            aria-label="Open menu"
            onClick={() => setMenuOpen(true)}
            ref={menuButtonRef}
          >
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
        {/* Side menu overlay */}
        <div
          className={classnames(
            styles.sideMenu,
            menuOpen && styles.sideMenuOpen
          )}
          ref={menuRef}
        >
          <button
            className={styles.closeButton}
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
            style={{ alignSelf: 'flex-end', padding: '0.5rem', margin: '1rem' }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
          <nav className={styles.sideMenuLinks} style={{ alignItems: 'flex-start', padding: '2rem 2rem 0 2rem', gap: '1.5rem' }}>
          <a
              href="https://wa.me/447475703912"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.menuLink + ' ' + styles.boldLeft}
              style={{ fontWeight: '600', textAlign: 'left' }}
            >
              Chat on WhatsApp
            </a>
            <a
              href="/"
              className={styles.menuLink + ' ' + styles.boldLeft}
              style={{ fontWeight: '600', textAlign: 'left' }}
            >
              Book a repair
            </a>
            {authStore.isAuthenticated ? (
              <button
                onClick={() => navigateTo('/orders')}
                className={styles.menuLink + ' ' + styles.boldLeft}
              >
                My Orders
              </button>
            ) : (
              <button
                onClick={() => navigateTo('/login')}
                className={styles.menuLink + ' ' + styles.boldLeft}
                style={{ fontWeight: '600', textAlign: 'left', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
              >
                Login
              </button>
            )}
            <a
              href="https://www.repatch.co.uk/faq"
              className={styles.menuLink + ' ' + styles.boldLeft}
              style={{ fontWeight: '600', textAlign: 'left' }}
            >
              FAQ
            </a>
            <a
              href="https://www.repatch.co.uk/about"
              className={styles.menuLink + ' ' + styles.boldLeft}
              style={{ fontWeight: '600', textAlign: 'left' }}
            >
              About Repatch
            </a>
            <a
              href="https://www.repatch.co.uk/contact"
              className={styles.menuLink + ' ' + styles.boldLeft}
              style={{ fontWeight: '600', textAlign: 'left' }}
            >
              Contact
            </a>
            {authStore.isAuthenticated && (
              <button
                onClick={() => navigateTo('logout')}
                className={styles.menuLink + ' ' + styles.boldLeft}
                style={{ fontWeight: '600', textAlign: 'left', background: 'none', border: 'none', padding: 0, cursor: 'pointer', marginTop: '2rem' }}
              >
                Logout
              </button>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default observer(RepatchHeader);
